module.exports = __webpack_public_path__ + "static/media/tlyfe-mobile.449c7b15.png";